import Cookie from "universal-cookie";

const getAuthHeader = () => {
  const cookies = new Cookie();
  const token = cookies.get("token");

  if (!token) return {};

  return {
    Authorization: `Bearer ${token}`,
  };
};

export default getAuthHeader;
